import { Base } from "@studiometa/js-toolkit";
import { nextFrame, domScheduler, isFunction } from "@studiometa/js-toolkit/utils";
class AbstractSliderChild extends Base {
  /**
   * Config.
   */
  static config = {
    name: "AbstractSliderChild"
  };
  /**
   * Listen to the `goto` event of the parent on mount.
   */
  mounted() {
    this.$parent.$on("index", this);
  }
  /**
   * Trigger update on resize.
   */
  resized() {
    nextFrame(() => {
      this.update(this.$parent.currentIndex);
    });
  }
  /**
   * Remove the event listener.
   */
  destroyed() {
    this.$parent.$off("index", this);
  }
  /**
   * Dispatch event.
   */
  handleEvent(event) {
    if (event.type === "index") {
      domScheduler.read(() => {
        const callback = this.update(event.detail[0]);
        if (isFunction(callback)) {
          domScheduler.write(() => {
            callback();
          });
        }
      });
    }
  }
  /**
   * Update the child component with the given index.
   */
  update(index) {
    throw new Error(`The \`AbstractSliderChild.update(${index})\` method must be implemented.`);
  }
}
export {
  AbstractSliderChild
};
//# sourceMappingURL=AbstractSliderChild.js.map
